import script from "./custom-fields.vue?vue&type=script&setup=true&lang=js"
export * from "./custom-fields.vue?vue&type=script&setup=true&lang=js"

import "./custom-fields.vue?vue&type=style&index=0&id=073ba810&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-073ba810"]])

export default __exports__